export default __webpack_public_path__ + "static/gdansk-877478d156ed66a5ecbe15b116af4956.png";